import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ProfileCompletionBanner.css';

/**
 * ProfileCompletionBanner Component
 * 
 * Displays a prominent banner for users with incomplete profiles (those with "Other" identity)
 * Guides users to complete their profile by requesting or updating their identity
 */
function ProfileCompletionBanner() {
  const [profileStatus, setProfileStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadProfileStatus();
  }, []);

  const loadProfileStatus = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const headers = { Authorization: `Bearer ${token}` };
      
      const response = await axios.get('/api/users/profile-status', { headers });
      setProfileStatus(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error loading profile status:', error);
      setLoading(false);
    }
  };

  const handleUpdateIdentity = () => {
    navigate('/profile');
  };

  const handleDismiss = () => {
    setDismissed(true);
    // Store dismissal in session storage (will reappear on next login)
    sessionStorage.setItem('profileBannerDismissed', 'true');
  };

  // Don't show if loading, dismissed, or profile is complete
  if (loading || dismissed || !profileStatus || profileStatus.isComplete) {
    return null;
  }

  // Check if dismissed in this session
  if (sessionStorage.getItem('profileBannerDismissed') === 'true') {
    return null;
  }

  return (
    <div className="profile-completion-banner">
      <div className="banner-icon">⚠️</div>
      <div className="banner-content">
        <h3>Complete Your Profile</h3>
        <p>
          {profileStatus.pendingCategoryRequest?.status === 'pending' && (
            <>Your category request is being reviewed. We'll notify you when it's approved.</>
          )}
          {profileStatus.pendingCategoryRequest?.status === 'approved' && (
            <>Your category "{profileStatus.pendingCategoryRequest.categoryName}" has been approved! Update your identity now.</>
          )}
          {!profileStatus.pendingCategoryRequest && (
            <>You selected "Other" as a placeholder. Request your specific identity category to complete your profile.</>
          )}
        </p>
        <div className="banner-actions">
          <button 
            className="btn-update"
            onClick={handleUpdateIdentity}
          >
            {profileStatus.pendingCategoryRequest?.status === 'approved' 
              ? '✓ Update Identity' 
              : '📝 Request Category'}
          </button>
          <button 
            className="btn-dismiss"
            onClick={handleDismiss}
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProfileCompletionBanner;
